export default "__VITE_ASSET__DlXnrgr___"